import { app } from '../../app.module'
/**
 * 投稿タイプフォーム
 * @class PostTypeFormCtrl
 */
class PostTypeFormCtrl {
  private snsType: string
  private postTypeList: {
    type: string
    name: string
  }[]
  private postType: string
  private onChange: Function

  /**
   * 初期化イベント
   */
  public $onInit() {
    // 投稿タイプの初期化
    this.initPostTypeList()
    // 投稿タイプをしている場合は、投稿タイプを変更する
    if (this.postType) {
      this.changePostType()
    }
  }

  /**
   * 投稿タイプの変更
   */
  public changePostType() {
    if (typeof this.onChange === 'function') {
      this.onChange({ postType: this.postType })
    }
  }

  /**
   * 投稿タイプの初期化
   * @return {void}
   */
  private initPostTypeList(): void {
    let postTypeList = []
    switch (this.snsType) {
      case 'facebook':
        postTypeList = [
          {
            type: '',
            name: '指定なし',
          },
          {
            type: 'text',
            name: 'テキスト',
          },
          {
            type: 'link',
            name: 'リンク',
          },
          {
            type: 'photo',
            name: '画像',
          },
          {
            type: 'album',
            name: 'アルバム',
          },
          {
            type: 'carousel',
            name: 'カルーセル',
          },
          {
            type: 'video',
            name: 'ビデオ',
          },
          {
            type: '360-video',
            name: '360°ビデオ',
          },
          {
            type: 'live-video',
            name: 'ライブビデオ',
          },
          {
            type: 'animation-gif',
            name: 'アニメーションGIF',
          },
          {
            type: 'offer',
            name: 'クーポン',
          },
          {
            type: 'note',
            name: 'ノート',
          },
          {
            type: 'rich_media',
            name: 'キャンバス',
          },
        ]
        break
      case 'twitter':
        postTypeList = [
          {
            type: '',
            name: '指定なし',
          },
          {
            type: 'text',
            name: 'テキスト',
          },
          {
            type: 'photo',
            name: '画像',
          },
          {
            type: 'video',
            name: 'ビデオ',
          },
          {
            type: 'animation-gif',
            name: 'アニメーションGIF',
          },
        ]
        break
      case 'instagram':
        postTypeList = [
          {
            type: '',
            name: '指定なし',
          },
          {
            type: 'photo',
            name: '画像',
          },
          {
            type: 'video',
            name: 'ビデオ',
          },
          {
            type: 'carousel',
            name: 'カルーセル',
          },
        ]
        break
      case 'line':
        postTypeList = [
          {
            type: '',
            name: '指定なし',
          },
          {
            type: 'photo',
            name: '画像',
          },
          {
            type: 'video',
            name: 'ビデオ',
          },
        ]
        break
      case 'tiktok':
        postTypeList = [
          {
            type: '',
            name: '指定なし',
          },
          {
            type: 'video',
            name: 'ビデオ',
          },
          {
            type: 'carousel',
            name: 'カルーセル',
          },
        ]
        break
    }

    this.postTypeList = postTypeList
  }
}

/**
 * 投稿タイプフォーム
 * attr: {string} snsType SNSタイプ
 * attr: {string} postType 選択している投稿タイプ
 * attr: {function} onChange 投稿タイプの変更イベント
 */
app.component('postTypeForm', {
  bindings: {
    snsType: '<',
    postType: '<',
    onChange: '&',
  },
  template: require('./post-type-form.pug')(),
  controller: PostTypeFormCtrl,
})
